(() => {
  'use strict';
  const money = cents => new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' }).format(cents / 100);

  function init() {
    if (document.querySelector('.nn-live-sticky-atc')) return;
    const surfaces = [...document.querySelectorAll('.paper-product[data-product-handle]')];
    if (!surfaces.length) return;

    // Keep the full source-sized gallery visible in short viewports without shrinking its media.
    const galleryResizeObserver = typeof ResizeObserver === 'undefined' ? null : new ResizeObserver(entries => {
      entries.forEach(entry => {
        const gallery = entry.target;
        if (window.matchMedia('(min-width: 901px)').matches && entry.contentRect.width > 0) {
          gallery.style.setProperty('--nn-gallery-sticky-height', entry.contentRect.height + 'px');
        } else {
          gallery.style.removeProperty('--nn-gallery-sticky-height');
        }
      });
    });
    surfaces.forEach(surface => {
      const gallery = surface.querySelector('.paper-product-gallery');
      if (gallery) galleryResizeObserver?.observe(gallery);
    });
    window.addEventListener('resize', () => {
      surfaces.forEach(surface => {
        const gallery = surface.querySelector('.paper-product-gallery');
        if (gallery && !galleryResizeObserver) gallery.style.removeProperty('--nn-gallery-sticky-height');
      });
    }, { passive: true });

    const bar = document.createElement('aside');
    bar.className = 'nn-live-sticky-atc';
    bar.setAttribute('aria-label', 'Snel naar je product');
    bar.setAttribute('aria-hidden', 'true');
    bar.inert = true;
    bar.innerHTML = '<div class="nn-live-sticky-atc__inner"><div class="nn-live-sticky-atc__product"><img class="nn-live-sticky-atc__image" alt="" width="60" height="60"><div class="nn-live-sticky-atc__copy"><div class="nn-live-sticky-atc__title"></div><div class="nn-live-sticky-atc__price"></div></div></div><button type="button" class="nn-live-sticky-atc__button">IN WINKELWAGEN</button></div>';
    document.body.append(bar);
    const image = bar.querySelector('.nn-live-sticky-atc__image');
    const title = bar.querySelector('.nn-live-sticky-atc__title');
    const price = bar.querySelector('.nn-live-sticky-atc__price');
    const stickyButton = bar.querySelector('.nn-live-sticky-atc__button');
    const drawer = document.querySelector('#paper-cart-overlay');
    const footer = document.querySelector('footer');
    let activeSurface = null;
    let heroButton = null;
    let drawerObserver = null;
    let footerObserver = null;
    let footerInView = false;

    const visible = element => {
      if (!element || !element.isConnected || getComputedStyle(element).display === 'none') return false;
      const rect = element.getBoundingClientRect();
      return rect.width > 0 && rect.height > 0;
    };
    const surfaceForViewport = () => surfaces.find(surface => visible(surface.querySelector('.nn-add'))) || surfaces.find(visible) || surfaces[0];
    const firstProductImage = surface => surface.querySelector('.paper-gallery-thumbnails .paper-thumbnail:first-child img') || surface.querySelector('.paper-product-gallery img');
    const currentOffer = surface => {
      const handle = surface.dataset.productHandle;
      const apiOffer = window.NoleePreview?.getOffer?.(handle);
      if (apiOffer) return apiOffer;
      const selected = surface.querySelector('[data-action="bundle"][aria-pressed="true"]');
      const strong = selected?.querySelector('.nn-bundle-price strong');
      const compare = selected?.querySelector('.nn-bundle-price s');
      const toCents = value => Math.round(Number((value || '').replace(/[^\d,.-]/g, '').replace(/\./g, '').replace(',', '.')) * 100);
      return { price: toCents(strong?.textContent), compare: toCents(compare?.textContent) };
    };
    const sync = () => {
      activeSurface = surfaceForViewport();
      if (!activeSurface) return;
      heroButton = activeSurface.querySelector('.nn-add');
      const heading = activeSurface.querySelector('.paper-product-information h1');
      const sourceImage = firstProductImage(activeSurface);
      if (heading) title.textContent = heading.textContent.trim();
      if (sourceImage?.src) {
        image.src = sourceImage.currentSrc || sourceImage.src;
        image.alt = sourceImage.alt || heading?.textContent.trim() || '';
      }
      const offer = currentOffer(activeSurface);
      const selectedVariant = offer?.variant;
      const cents = Number(offer?.price ?? selectedVariant?.price);
      const compareCents = Number(offer?.compare ?? selectedVariant?.compare);
      if (Number.isFinite(cents)) {
        // 16 okt: wat je betaalt + voor hoeveel stuks; bij een bundel ook de oude prijs doorgestreept (Quinn: korting moet zichtbaar zijn).
        const units = Math.max(1, parseInt(((offer?.offer_key || '').match(/pack-(\d+)/) || [])[1] || '1', 10));
        const handle = activeSurface.dataset.productHandle || '';
        const plural = /^bundel-/.test(handle) ? 'sets' : /^zeep-/.test(handle) ? 'zeepjes' : 'flesjes';
        const showCompare = units > 1 && Number.isFinite(compareCents) && compareCents > cents;
        price.innerHTML = '<strong>' + money(cents) + '</strong>' + (showCompare ? '<s>' + money(compareCents) + '</s>' : '') + (units > 1 ? '<span class="nn-live-sticky-atc__per">voor ' + units + ' ' + plural + '</span>' : '');
      }
      stickyButton.disabled = !heroButton || heroButton.disabled;
      stickyButton.setAttribute('aria-label', (title.textContent ? title.textContent + ' in je winkelwagen leggen' : 'In je winkelwagen leggen'));
    };
    const show = shouldShow => {
      const open = shouldShow && !footerInView && !(drawer && !drawer.hidden);
      bar.classList.toggle('is-visible', open);
      bar.setAttribute('aria-hidden', String(!open));
      bar.inert = !open;
    };
    const updateVisibility = () => {
      if (!heroButton?.isConnected) sync();
      // The live Smooche theme shows this strip at a fixed 1,300px document offset.
      show(!!heroButton && heroButton.getBoundingClientRect().bottom < 0);
    };

    sync();
    window.addEventListener('scroll', updateVisibility, { passive: true });
    window.addEventListener('resize', () => { sync(); updateVisibility(); }, { passive: true });
    document.addEventListener('nolee:offer-change', () => { sync(); updateVisibility(); });
    document.addEventListener('click', event => {
      if (event.target.closest('[data-action="bundle"]')) requestAnimationFrame(sync);
      if (event.target.closest('[data-action="open-drawer"], [data-action="add"], .nn-live-sticky-atc__button')) requestAnimationFrame(updateVisibility);
    });
    stickyButton.addEventListener('click', () => {
      sync();
      const addButton = activeSurface?.querySelector('.nn-add');
      if (addButton && !addButton.disabled) { addButton.click(); return; }
      const productAnchor = activeSurface?.querySelector('[data-paper-layer="Product heading"] h1') || activeSurface?.querySelector('.paper-product-information h1');
      productAnchor?.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
    });
    surfaces.forEach(surface => new MutationObserver(() => sync()).observe(surface, {
      subtree: true, attributes: true, attributeFilter: ['aria-pressed', 'src'], childList: true, characterData: true
    }));
    if (drawer) {
      drawerObserver = new MutationObserver(updateVisibility);
      drawerObserver.observe(drawer, { attributes: true, attributeFilter: ['hidden', 'class'] });
    }
    if (footer) {
      footerObserver = new IntersectionObserver(entries => {
        footerInView = entries.some(entry => entry.isIntersecting);
        updateVisibility();
      }, { threshold: 0 });
      footerObserver.observe(footer);
    }
    updateVisibility();
  }

  function waitForPreview() {
    if (window.NoleePreview) return init();
    if (document.readyState === 'complete') return init();
    window.setTimeout(waitForPreview, 100);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', waitForPreview, { once: true });
  else waitForPreview();
})();
